import { useMemo } from 'react'
import { Contact } from '../../../api/contacts/types'
import { ContactType } from '../../../api/globalTypes'
import { companyOtherInfoInputs } from '../../../common/forms/company/inputs'
import { companyOtherInfoValidation } from '../../../common/forms/company/validations'
import { contactOtherInfoInputs } from '../../../common/forms/contacts/inputs'
import { contactOtherInfoValidation } from '../../../common/forms/contacts/validations'

export const useContactOtherInfoFormConfig = (data: Contact | null, contactType: ContactType = ContactType.Person) => {
    const otherInfoInputs = useMemo(() => {
        return contactType === ContactType.Person ? contactOtherInfoInputs() : companyOtherInfoInputs()
    }, [contactType])

    const otherInfoValidationConfig = useMemo(() => {
        return contactType === ContactType.Person ? contactOtherInfoValidation(data) : companyOtherInfoValidation(data)
    }, [data, contactType])

    return {
        otherInfoInputs,
        otherInfoValidationConfig,
    }
}
